import React, { useState, useEffect } from "react";
import "./style.css";

const defaultCard = {
  uid: "001",
  title: "310.2 Powers and duties of department",
  code: "2",
  side1: ["Responsibilities.--"],
  side2: [
    "",
    "The,commissioner,shall,do,all,of,the,following:",
    "License,insurance,producers,in,accordance,with,this",
    "Approve,and,administer,or,contract,for,the,overall,administration,of,the,preexamination,program,,preexamination,courses,of,study,,insurance,producer,licensing,examinations,and,continuing,education,programs.,A,preexamination,education,program,approved,by,the,department,shall,include,no,less,than,three,credit,hours,on"
  ]
};

function PAFlashcards() {
  const [activeCardSide, setActiveCardSide] = useState(1);
  const [_activeCards, setActiveCards] = useState([]);
  const [loadedCard, setLoadedCard] = useState(defaultCard);
  const [paFlashCards] = useState([]);

  useEffect(() => {
    const cards = [];
    for (let i = 0; i < paFlashCards.length; i++) {
      if (paFlashCards[i] !== undefined) {
        if (paFlashCards[i].length > 1) {
          for (let j = 0; j < paFlashCards[i].length; j++) {
            cards.push(paFlashCards[i][j]);
          }
        } else if (paFlashCards[i].length === 1) {
          cards.push(paFlashCards[i][0]);
        }

        if (i === paFlashCards.length - 1) {
          setActiveCards(cards);
          setLoadedCard(cards[Math.floor(Math.random() * cards.length)]);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const flipSide = (num) => {
    setActiveCardSide(num);
  };

  const skip = () => {
    console.log("Skipping Card...");
  };

  const stash = () => {
    console.log("Stashing Card...");
  };

  return (
    <div>
      <div
        className="card"
        style={{ backgroundColor: "white", height: "1000px", overflow: "auto" }}
      >
        <div
          className="card-body"
          style={{
            padding: "20px",
            backgroundImage: "url(https://picsum.photos/800)",
            backgroundSize: "cover"
          }}
        >
          <div className="row">
            <div className="col-1"></div>
            <div className="col-10">
              <div className="card" style={{ textAlign: "center" }}>
                <div className="card-header">
                  <h3>{loadedCard.title}</h3>
                </div>
                <div className="card-body">
                  {activeCardSide === 1 ? (
                    <span>
                      <span>
                        <h4>{loadedCard.uid}</h4>
                        <button onClick={() => flipSide(2)}>Flip</button>
                      </span>
                    </span>
                  ) : (
                    <span>
                      {loadedCard.side2.map((textArr, index) => (
                        <p key={index}>{textArr.join(" ")}</p>
                      ))}
                      <button onClick={() => flipSide(1)}>Flip</button>
                      <button onClick={() => skip()}>Skip</button>
                      <button onClick={() => stash()}>Stash</button>
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="col-1"></div>
          </div>
          <div className="row" style={{ marginTop: "100px" }}>
            <div className="col-1"></div>
            <div className="col-5">
              <div className="card" style={{ textAlign: "center" }}>
                <div className="card-header">
                  <h3>Cards Memorized</h3>
                </div>
                <div className="card-body">
                  <h1>
                    <strong>5</strong>
                  </h1>
                </div>
              </div>
            </div>

            <div className="col-5">
              <div className="card" style={{ textAlign: "center" }}>
                <div className="card-header">
                  <h3>Cards Remaining</h3>
                </div>
                <div className="card-body">
                  <h1>
                    <strong>45</strong>
                  </h1>
                </div>
              </div>
            </div>
            <div className="col-1"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PAFlashcards;
